// extracted by mini-css-extract-plugin
export var copyIcon = "_sd-2";
export var discountCard = "_sd-0";
export var discountCode = "_sd-3";
export var discountContent = "_sd-1";
export var loadingCard = "_sd-4";